import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The actions row at the bottom of a dialog: content components put their
 * buttons inside it. Right-aligned; styling lives in `@seahorse/theme`'s
 * `_dialog.scss` (`.dialog-footer`).
 */
@Component({
  selector: 'sh-dialog-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  host: { class: 'dialog-footer' },
  template: '<ng-content></ng-content>',
})
export class DialogFooterComponent {}
